import { Spin } from 'antd'
import { Logo } from 'assets'
import { typeUserConst } from 'constant'
import useAuth from 'hooks/useAuth'
import React, { Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import WhatsappButton from 'components/atoms/WhatsappButton'
import { ScrollToTop } from 'utils/ScrollToTop'
import PopupNotification from 'components/organisms/PopupNotification'

const ProtectedBasicLayout = () => {
  const { pathname } = useLocation()
  const { userType } = useAuth()
  if (userType === typeUserConst.UNDECIDED && !pathname.includes('onboarding')) {
    return <Navigate to={'/onboarding'} replace={true} />
  }
  return (
    <main className="min-h-screen relative flex-col flex">
      <PopupNotification />
      <ScrollToTop />
      <header className="w-full py-4 px-10 xl:px-[156px] sticky top-0 z-[200] bg-white flex justify-between items-center">
        <Logo />
      </header>
      <div className="size-full flex-grow">
        <Suspense
          fallback={
            <div
              className="
        flex justify-center items-center flex-col h-screen w-full flex-grow">
              <Spin size="large" spinning={true}></Spin>
            </div>
          }>
          <Outlet />
        </Suspense>
      </div>
      <WhatsappButton />
      <footer className="bg-surface-primary-3 py-4 flex justify-center items-center">
        <span className="text-primary text-sm">© 2025 TOMAZZ. All rights reserved.</span>
      </footer>
    </main>
  )
}

export default ProtectedBasicLayout
